/**
 * The roadmap studio's way in (docs/PLAN-roadmap-changelog-20261020.md, R3): the account menu offers /admin/roadmap only
 * in Prest0 Inc.'s workspace, and only to someone holding `roadmap.items.view`.
 *
 * Both halves are needed, as for the insights studio (useInsightsStudioAccess.ts): `hasPermission` answers true for the
 * owner of ANY workspace, while the roadmap keys exist only in Prest0 Inc. (the server strips them everywhere else and
 * refuses them before its owner pass). The workspace is the ACTIVE one, never the home org.
 *
 * This hides chrome only. The route's DeveloperRoute and every callable decide (functions/src/roadmap/roadmapAccess.ts).
 */
import { PREST0_INC_ACCOUNT_ID } from '../config/internalAccess';
import { useActiveWorkspaceAccountId } from './useInsightsStudioAccess';

/** The key the studio's route asks for (src/App.tsx), and so the key its way in asks for. */
export const ROADMAP_STUDIO_KEY = 'roadmap.items.view';

/** The permission answer the rule needs (useUsageVisibility's `loading` and `hasPermission`). */
export interface RoadmapStudioPermissions {
  loading?: boolean;
  hasPermission?: (key: string) => boolean;
}

/** May the way in show, in this workspace, for this permission answer? False while it loads (fail closed). Pure. */
export function canSeeRoadmapStudio(activeAccountId: string | null, perms: RoadmapStudioPermissions): boolean {
  if (perms.loading || typeof perms.hasPermission !== 'function') return false;
  return activeAccountId === PREST0_INC_ACCOUNT_ID && perms.hasPermission(ROADMAP_STUDIO_KEY);
}

export { useActiveWorkspaceAccountId };
